import { MessageDialog } from '../../framework/frontend/MessageDialog';
import { GlobalImport } from './GlobalImport';
export class BrowserHandler {
  static init(): BrowserHandler {
    const handler = new BrowserHandler();
    handler.suppressConsole();
    return handler;
  }

  static isInIFrame(): boolean {
    return !(window === window.parent);
  }

  isSmartDevice(): boolean {
    const has_iPhone = navigator.userAgent.indexOf('iPhone') > 0;
    const has_android = navigator.userAgent.indexOf('Android') > 0;
    const has_iPod = navigator.userAgent.indexOf('iPod') > 0;
    const has_iPad = navigator.userAgent.indexOf('iPad') > 0;
    return has_iPhone || has_android || has_iPod || has_iPad;
  }

  /**
   * コピーガードコールバックメソッド
   */
  copyGuard(e: ClipboardEvent): void {
    // デフォルトのカット処理をキャンセル
    e.preventDefault();

    MessageDialog.alert('コピーはできません');

    // DataTransfer オブジェクトを取得する
    const data_transfer = e.clipboardData;
    // 文字列データを格納する
    data_transfer.setData('text', '');
  }

  /**
   * ペーストガードコールバックメソッド
   */
  pasteGuard(e: Event): void {
    // デフォルトのカット処理をキャンセル
    e.preventDefault();

    MessageDialog.alert('ペーストはできません');
  }

  suppressConsole(): void {
    const hostName = location.hostname;
    // if (hostName == 'localhost' || hostName == '127.0.0.1') {
    //   console.info(
    //     'localhost 以外では console.log が無効化されます!! suppressConsole 現在:',
    //     location.hostname + ' consoleは有効です'
    //   );
    // } else {
    //   console.info('console.log を無効化しました!!', location.hostname);
    //   GlobalImport.getAnyWindow().console = {};
    //   window.console.log = function () {
    //     return;
    //   };
    //   window.console.time = function () {
    //     return;
    //   };
    //   window.console.timeEnd = function () {
    //     return;
    //   };
    //   window.console.dir = function () {
    //     return;
    //   };
    //   window.console.warn = function () {
    //     return;
    //   };
    // }
  }

  /**
   * キャンバスの圧縮
   * @param {} canvas
   */
  static compressImage(canvas: HTMLCanvasElement): HTMLCanvasElement {
    const comp_canvas: HTMLCanvasElement = document.createElement('canvas');
    const comp_ctx = comp_canvas.getContext('2d', {});
    const dstWidth = 600;
    const dstHeight = 315;
    comp_canvas.width = dstWidth;
    comp_canvas.height = dstHeight;
    comp_ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, dstWidth, dstHeight);
    return comp_canvas;
  }

  /**
   *
   * @param  {[type]} string [description]
   * @return {[type]}        [description]
   */
  execCopy(str: string): boolean {
    const temp: HTMLTextAreaElement = document.createElement('textarea');

    temp.value = str;
    temp.selectionStart = 0;
    temp.selectionEnd = temp.value.length;

    const s = temp.style;
    s.position = 'display:none';

    document.body.appendChild(temp);
    temp.focus();
    const result = document.execCommand('copy');
    temp.blur();
    document.body.removeChild(temp);
    // true なら実行できている falseなら失敗か対応していないか
    return result;
  }

  // 画面サイズを取得
  getCurrentSize(): string {
    let winSize = 'xs'; // default value, check for actual size
    if (document.body.clientWidth >= 1200) {
      winSize = 'lg';
    } else if (document.body.clientWidth >= 992) {
      winSize = 'md';
    } else if (document.body.clientWidth >= 768) {
      winSize = 'sm';
    }
    return winSize;
  }

  /**
   * スマートフォンサイズであることを確認
   * @returns
   */
  static isSmartPhone(): boolean {
    return document.body.clientWidth < 1000;
  }

  static getExecuteUrl(user_id: number, project_id: string): string {
    // const host = location.host === `blockvrock.com` ? 'run.blockvrock.com' : location.host.startsWith(`192.168`) ? `localhost` : location.host;
    const host = location.host.startsWith(`192.168`) ? `localhost` : location.host;

    return `${location.protocol}//${host}/exec.html?user_id=${user_id}&project_id=${project_id}`;
  }
}
